export default __webpack_public_path__ + "static/media/uniqshowday.c308f1b2.svg";